import * as React from "react";
import {connect} from 'react-redux';


import AssociationState, {FeatureTypeAttributes} from "../../state/AssociationsState"
import ContractChildAssociationTab from './ContractChildAssociationTab';
import NvdbChildAssociationTab from './NvdbChildAssociationsTab';
import NvdbParentAssociationTab from './NvdbParentAssociationTab';
import {
    DisplayFeatureType,
    AssociationScope,
    CommonAssociationFeature,
    DisplayFeature,
    UserSession,
} from "../../../contract-features-3/domain";
import {
    selectTargetFeatureType,
    toggleSelectedAssociationTarget,
    associateTargets,
    disAssociateTargets,
    showNvdbFeatures,
    tabChange,
    setNvdbSearchDistance,
    SetNvdbSearchDistance,
    SelectTargetFeatureType,
    ToggleSelectedAssociationTarget,
    DisAssociateTargets
} from "../../../../actions/actions";
import {AssociatedFeature} from "../../domain/AssociatedFeature";
import {AssociationJson} from "../../domain/AssociationJson";
import AssociationInfo from "../AssociationInfo";
import {FeatureTypeSummary} from "../../../../../integration/representation/feature-type";


interface AssociationCreatorProps {
    selectedAssociation: AssociatedFeature;
    selectedAssociationTargetType: FeatureTypeAttributes;
    selectedTargetFeatures: CommonAssociationFeature[]
    selectedSourceFeature: DisplayFeature;

    featureTypes: FeatureTypeSummary[];
    associationTargetTypes: DisplayFeatureType[];
    targetFeatures: CommonAssociationFeature[];
    associationsFlat: AssociationJson[];

    user: UserSession;

    onSelectTargetFeatureType: SelectTargetFeatureType;
    onSelectTargetFeature: ToggleSelectedAssociationTarget;
    onAssociateTargets: Function;
    onDisassociateTargets: DisAssociateTargets;
    onTabSwitch: Function;
    onFetchNvbdObjects: Function;

    nvdbSearchDistance: number;
    setNvdbSearchDistance: SetNvdbSearchDistance;

    tab: AssociationScope;
}

interface AssociationCreatorState {
}

class AssociationCreator extends React.Component<AssociationCreatorProps, AssociationCreatorState> {

    constructor(props: AssociationCreatorProps) {
        super(props);
    }

    render() {
        let activeTab = this.props.tab;
        return (
            <div id="associations-creator-container">




                {this.props.tab != null &&
                <div className="navlist">
                    <div onClick={() => this.chooseTab("PROJECT_TO_PROJECT")}
                         className={"navspan" + (activeTab == "PROJECT_TO_PROJECT" ? " selected" : "")}>Kobling til datter i kontrakt
                    </div>
                    <div onClick={() => this.chooseTab("PROJECT_TO_NVDB")}
                         className={"navspan" + (activeTab == "PROJECT_TO_NVDB" ? " selected" : "")}>Kobling til datter i NVDB
                    </div>
                    <div onClick={() => this.chooseTab("NVDB_TO_PROJECT")}
                         className={"navspan" + (activeTab == "NVDB_TO_PROJECT" ? " selected" : "")}>Kobling til mor i NVDB
                    </div>
                </div>
                }
                {(() => {
                        switch (this.props.tab) {
                            case "PROJECT_TO_PROJECT":
                                return <ContractChildAssociationTab {...this.props}/>;
                            case "PROJECT_TO_NVDB":
                                return <NvdbChildAssociationTab {...this.props}/>;
                            case "NVDB_TO_PROJECT":
                                return <NvdbParentAssociationTab {...this.props}/>;
                            case null:
                                return <div className="welcome-text">
                                    <h2>Sammenkobling</h2>
                                    <div className="infobox">
                                        <p>Klikk på "Automatisk sammenkobling" eller velg et vegobjekt i venstremenyen
                                            for å utføre sammenkobling</p>
                                    </div>
                                </div>;
                            default:
                                throw "Error in state. Tab not implemented";
                        }
                    })()}

                <AssociationInfo />


            </div>

        )
    }

    chooseTab(tab: AssociationScope) {
        this.props.onTabSwitch(tab);
    }
}

const mapStatToProps = (state: AssociationState) => {
    return {
        selectedAssociation: state.selectedAssociation,
        selectedAssociationTargetType: state.selectedAssociationTargetType,
        selectedTargetFeatures: state.selectedTargetFeatures,
        featureTypes: state.featureTypes,
        associationTargetTypes: state.targetAssociationTypes,
        targetFeatures: state.targetFeatures,
        tab: state.tab,
        associationsFlat: state.associationsFlat,
        nvdbSearchDistance: state.nvdbSearchDistance,
        selectedSourceFeature: state.selectedSourceFeature,
        user: state.user,
    };
};

const mapDispatchToProps = {
    onSelectTargetFeatureType: selectTargetFeatureType,
    onSelectTargetFeature: toggleSelectedAssociationTarget,
    onAssociateTargets: associateTargets,
    onDisassociateTargets: disAssociateTargets,
    onTabSwitch: tabChange,
    onFetchNvbdObjects: showNvdbFeatures,
    setNvdbSearchDistance: setNvdbSearchDistance
};


export default connect(mapStatToProps, mapDispatchToProps)(AssociationCreator);